import type { Dict } from './en'

export const fa: Dict = {
  meta: { name: 'فارسی', dir: 'rtl' as const, code: 'fa', voice: 'fa-IR' },

  app: {
    name: 'نابوسو',
    tagline: 'یکی که با تو بیدار است.',
  },

  common: {
    continue: 'ادامه',
    back: 'بازگشت',
    done: 'تمام',
    skip: 'رد کن',
    close: 'بستن',
    save: 'ذخیره',
    cancel: 'انصراف',
    stop: 'توقف',
    start: 'شروع',
    next: 'بعدی',
    minutes: 'دقیقه',
    today: 'امروز',
    yesterday: 'دیروز',
    none: 'هیچ‌کدام',
    optional: 'اختیاری',
  },

  onboarding: {
    step1Title: 'این نابوسو است.',
    step1Body:
      'نابو، کاتب بابلی بود؛ کسی که لوح‌های سرنوشت را نگه می‌داشت. نابوسو شب‌های تو را ثبت می‌کند — تا وقتی که دوباره خودت بتوانی بخوابی.',
    step1Sub: 'کسی این را ساخت که یک هفته بیدار ماند.',

    step2Title: 'این چه چیزی نیست.',
    step2Body:
      'نابوسو پزشک نیست، روان‌درمانگر نیست و دارو نیست. نمی‌تواند تشخیص بدهد و هرگز به تو نمی‌گوید دوزت را تغییر بده.',
    step2Body2:
      'کاری که می‌تواند بکند این است: ساعت سه شب با تو بیدار بماند، به بدنت کاری بدهد که انجام دهد، و دفتری نگه دارد که بتوانی به یک پزشک واقعی نشان بدهی.',

    step3Title: 'این یکی را حتماً بخوان.',
    step3Body:
      'قطع ناگهانی بنزودیازپین‌ها — لورازپام، آلپرازولام، کلونازپام، دیازپام — می‌تواند تشنج بدهد و می‌تواند بکشد. این یکی از معدود دسته‌های دارویی است که قطع یک‌باره‌اش واقعاً خطرناک است.',
    step3Body2:
      'اگر مصرف می‌کنی، خودسرانه قطع نکن. از پزشک بخواه برایت کاهش تدریجی بنویسد. اگر همین حالا تمام کرده‌ای و دسترسی نداری، این را یک وضعیت اورژانس پزشکی بدان، نه آزمون اراده.',
    step3Ack: 'فهمیدم. خودسرانه و ناگهانی قطع نمی‌کنم.',

    step4Title: 'امشب چرا اینجایی؟',
    step4Body: 'این فقط لحن را عوض می‌کند. هر وقت خواستی تغییرش بده.',
    reasonInsomnia: 'خوابم نمی‌برد',
    reasonInsomniaSub: 'دارویی در کار نیست',
    reasonTapering: 'زیر نظر پزشک کم می‌کنم',
    reasonTaperingSub: 'کاهش تدریجی و تحت نظر',
    reasonForced: 'تمام کردم و چاره‌ای نداشتم',
    reasonForcedSub: 'بدون برنامه قطع شد',
    reasonCurious: 'فقط دارم می‌گردم',
    reasonCuriousSub: 'چیز فوری‌ای نیست',

    forcedWarnTitle: 'پس این را بخوان.',
    forcedWarnBody:
      'از دست دادن دسترسی به بنزودیازپین بدون کاهش تدریجی، یک وضعیت پزشکی است، نه امتحان شخصیت. خطر تشنج در همان چند روز اول از همه بیشتر است. با پزشک، درمانگاه یا اورژانس تماس بگیر و صریح بگو: بنزودیازپین مصرف می‌کردم و تمام کرده‌ام.',
    forcedWarnBody2:
      'نابوسو شب‌ها کنارت می‌ماند. ولی جای آن تماس را نمی‌گیرد.',

    step5Title: 'چه ساعتی بیایم سراغت؟',
    step5Body: 'هر شب، کمی قبل از وقتی که معمولاً می‌خواهی بخوابی.',

    ready: 'آماده‌ام',
  },

  home: {
    greetingNight: 'دیروقت است.',
    greetingDeepNight: 'ساعت‌های سخت.',
    greetingEvening: 'شب دارد بسته می‌شود.',
    greetingMorning: 'به صبح رسیدی.',
    greetingDay: 'خواب، در روز هم ساخته می‌شود.',

    nightsLogged: (n: number) => (n === 1 ? '۱ شب ثبت شده' : `${toFa(n)} شب ثبت شده`),
    nothingYet: 'هنوز شبی ثبت نشده.',

    ritual: 'آیین امشب',
    ritualSub: 'ده دقیقه. یک در را انتخاب کن.',

    breath: 'نفس',
    breathSub: 'اول بدن را آرام کن',
    mantra: 'مانترا',
    mantraSub: 'به ذهن یک جمله بده',
    drift: 'سفر',
    driftSub: 'مدتی جایی دیگر',
    sound: 'صدا',
    soundSub: 'باران، زمزمه، سکوت',

    rescue: 'سه بامداد',
    rescueSub: 'بیداری و ترسیده‌ای؟ این را بزن.',

    companion: 'حرف بزن',
    ledger: 'دفتر',
    checkin: 'گزارش صبح',
    settings: 'تنظیمات',
  },

  breath: {
    title: 'نفس',
    pick: 'یک ریتم انتخاب کن',
    inhale: 'دم',
    hold: 'نگه دار',
    exhale: 'بازدم',
    holdOut: 'خالی',
    rounds: (n: number) => `دور ${toFa(n)}`,
    finishedTitle: 'همین کافی است.',
    finishedBody: 'لازم نیست حس متفاوتی داشته باشی. فقط لازم بود انجامش بدهی.',
    guideVoice: 'راهنمای صوتی',
  },

  mantra: {
    title: 'مانترا',
    pick: 'جمله‌ای انتخاب کن که نگه داری',
    own: 'خودت بنویس',
    ownPlaceholder: 'یک جملهٔ کوتاه. زمان حال.',
    repeating: 'در حال تکرار',
    tapToStop: 'برای توقف، هرجا را لمس کن',
    speed: 'سرعت',
    slow: 'آهسته',
    medium: 'متوسط',
    fast: 'یکنواخت',
  },

  drift: {
    title: 'سفر',
    pick: 'کجا می‌خواهی بروی؟',
    playing: 'در حال پخش',
  },

  sound: {
    title: 'صدا',
    off: 'خاموش',
    brown: 'نویز عمیق',
    rain: 'باران',
    drone: 'زمزمه',
    hush: 'هیس',
    heart: 'ضربان آرام',
    volume: 'بلندی',
    timer: 'محو شدن بعد از',
    noTimer: 'محو نشو',
  },

  night3am: {
    title: 'در بدترین ساعت بیداری.',
    intro: 'سعی نکن بخوابی. کار امشب این نیست. کار این است که از این یک ساعت رد شوی.',
    step: (n: number, total: number) => `${toFa(n)} از ${toFa(total)}`,

    s1Title: 'اول: بیدار بودن تو را نمی‌کشد.',
    s1Body:
      'تپش قلب، گرما، وحشت، بدنی که آرام نمی‌گیرد — این شکلِ یک سیستم عصبی است که ترمزش را از دست داده. وحشتناک است. ولی پایان تو نیست.',

    s2Title: 'بازدم را از دم بلندتر کن.',
    s2Body: 'فقط دایره را دنبال کن. هیچ چیز دیگر. اگر گمش کردی، از اول.',

    s3Title: 'بگو کجایی.',
    s3Body:
      'پنج چیز که می‌بینی. چهار چیز که می‌شنوی. سه چیز که لمس می‌کنی. اگر می‌توانی بلند بگو — صدا سریع‌تر از فکر تو را از حلقه بیرون می‌کشد.',

    s4Title: 'یک جمله.',
    s4Body: 'آن‌قدر تکرارش کن تا خسته‌کننده شود. خسته‌کننده شدن، هدف است.',

    s5Title: 'این ساعت تمام می‌شود.',
    s5Body:
      'هر بار قبلی تمام شده. در تاریکی بی‌حرکت دراز بکش. ساعت را نگاه نکن. نخوابیدن در حالت استراحت هم بی‌ارزش نیست.',

    logged: 'ثبت شد. این ساعت بیدار بودی و از آن رد شدی.',
    redFlagTitle: 'بعضی از این‌ها پزشک می‌خواهد، نه اپلیکیشن.',
    redFlagBody:
      'اگر تشنج کرده‌ای، چیزهایی می‌بینی یا می‌شنوی که وجود ندارند، شدیداً گیج هستی، استفراغت بند نمی‌آید، یا تب همراه با لرز داری — خواندن را قطع کن و همین حالا کمک اورژانسی بگیر. این‌ها اضطراب نیستند.',
    emergency: 'این یک اورژانس است',
  },

  ledger: {
    title: 'دفتر',
    sub: 'آنچه واقعاً اتفاق افتاد، شب به شب. این را برای پزشکت ببر.',
    empty: 'هنوز چیزی ثبت نشده. با استفاده از اپ، خودش پر می‌شود.',
    addDose: 'ثبت دوز',
    dose: 'دوز',
    medication: 'دارو',
    amount: 'مقدار',
    unit: 'میلی‌گرم',
    slept: 'خواب',
    hours: 'ساعت',
    wokeAt3: 'بیداری شبانه',
    symptoms: 'علائم',
    note: 'یادداشت',
    export: 'خروجی برای پزشک',
    exported: 'کپی شد. هرجا خواستی بچسبان.',
    streak: (n: number) => `${toFa(n)} شب با نابوسو`,
    trendBetter: 'خواب در دو هفتهٔ اخیر رو به بهبود است.',
    trendWorse: 'خواب رو به بدتر شدن است. ارزش گفتن به پزشکت را دارد.',
    trendFlat: 'تقریباً ثابت.',
    notEnough: 'چند شب دیگر، روند اینجا ظاهر می‌شود.',
  },

  checkin: {
    title: 'شب چطور بود؟',
    howLong: 'تقریباً چقدر خوابیدی؟',
    quality: 'چه حسی داشت؟',
    q1: 'افتضاح',
    q2: 'سخت',
    q3: 'قابل تحمل',
    q4: 'خوب',
    q5: 'خواب واقعی',
    woke: 'وسط شب بیدار شدی؟',
    yes: 'بله',
    no: 'نه',
    symptomsQ: 'چیزی در بدنت بود؟ (هرکدام را بزن)',
    saved: 'ثبت شد.',
    savedSub: 'یک شب دیگر روی لوح.',
  },

  symptoms: {
    anxiety: 'اضطراب',
    racingHeart: 'تپش قلب',
    sweating: 'تعریق',
    tremor: 'لرزش',
    nausea: 'تهوع',
    headache: 'سردرد',
    lightSensitivity: 'حساسیت به نور',
    soundSensitivity: 'حساسیت به صدا',
    muscleTension: 'گرفتگی عضلات',
    tinnitus: 'وزوز گوش',
    derealization: 'حس غیرواقعی بودن',
    dread: 'دلشوره',
    seizure: 'تشنج',
    hallucination: 'دیدن یا شنیدن چیزهای ناموجود',
    confusion: 'گیجی شدید',
    fever: 'تب همراه با لرز',
  },

  companion: {
    title: 'حرف بزن',
    sub: 'دیروقت است. هرچه در سرت هست بگو.',
    placeholder: 'اینجا بنویس…',
    offline: 'آفلاین — از آنچه روی همین دستگاه ذخیره شده پاسخ می‌دهم.',
    thinking: 'می‌شنوم…',
    disclaimer: 'پزشک نیست. هیچ‌چیز اینجا توصیهٔ پزشکی نیست.',
  },

  settings: {
    title: 'تنظیمات',
    language: 'زبان',
    ritualTime: 'ساعت آیین شبانه',
    notifications: 'یادآور شبانه',
    notificationsSub: 'یک تلنگر آرام سر ساعت آیین',
    enable: 'فعال کن',
    enabled: 'روشن',
    blocked: 'در تنظیمات مرورگرت مسدود شده',
    redShift: 'صفحهٔ گرم در شب',
    redShiftSub: 'نور آبی را بعد از تاریکی حذف می‌کند',
    voice: 'راهنمای گفتاری',
    haptics: 'لرزش',
    aiEndpoint: 'آدرس همراه هوشمند',
    aiEndpointSub: 'خالی بگذار تا کاملاً آفلاین بماند',
    reason: 'چرا اینجایی',
    data: 'داده‌های تو',
    dataSub: 'همه‌چیز روی همین دستگاه می‌ماند. چیزی آپلود نمی‌شود.',
    exportAll: 'خروجی همه‌چیز',
    wipe: 'حذف همه‌چیز',
    wipeConfirm: 'همهٔ شب‌ها، دوزها و یادداشت‌ها حذف شود؟ برگشتی ندارد.',
    about: 'درباره',
    safety: 'ایمنی',
    install: 'نصب نابوسو',
    installSub: 'به صفحهٔ خانه اضافه کن تا بدون اینترنت کار کند',
  },

  safety: {
    title: 'ایمنی',
    taperTitle: 'هرگز ناگهانی قطع نکن',
    taperBody:
      'ترک بنزودیازپین یکی از معدود ترک‌هایی است که می‌تواند بکشد. تشنج، دلیریوم و نوسان خطرناک فشار خون، خطرهای واقعی قطع یک‌باره هستند. هر کاهشی باید آهسته و زیر نظر پزشکِ تجویزکننده باشد. نابوسو هرگز دوز یا برنامه‌ای پیشنهاد نمی‌کند.',
    emergencyTitle: 'اگر این‌ها را داری، کمک اورژانسی بگیر',
    emergencyList: [
      'تشنج کرده‌ای، یا حس می‌کنی دارد می‌آید',
      'چیزهایی می‌بینی یا می‌شنوی که وجود ندارند',
      'نمی‌توانی درست فکر کنی یا نمی‌دانی کجایی',
      'تب همراه با لرز شدید داری',
      'نمی‌توانی مایعات را نگه داری',
      'به پایان دادن به زندگی‌ات فکر می‌کنی',
    ],
    emergencyBody:
      'با اورژانس محل زندگی‌ات تماس بگیر، یا خودت را به اورژانس برسان. بگو بنزودیازپین مصرف می‌کردی. همین یک جمله، نحوهٔ درمانت را عوض می‌کند.',
    crisisTitle: 'اگر به خودکشی فکر می‌کنی',
    crisisBody:
      'لطفاً همین امشب به یک آدم بگو — یک دوست، یکی از خانواده، یک خط بحران در کشورت. نابوسو نرم‌افزار است. نمی‌تواند آن‌طور که یک انسان کنارت می‌نشیند کنارت بنشیند، و امشب حق تو یک انسان است.',
  },

  install: {
    prompt: 'نابوسو را به صفحهٔ خانه اضافه کن',
    promptSub: 'بعد فوری باز می‌شود و بدون اینترنت کار می‌کند.',
    iosHint: 'دکمهٔ اشتراک‌گذاری را بزن، بعد «افزودن به صفحهٔ خانه».',
  },
}

/** Latin digits read as foreign in a Persian sentence; convert them. */
export function toFa(n: number | string): string {
  return String(n).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]!)
}
